import * as stylex from "@stylexjs/stylex";
import { breakpoints } from "../materials/consts.stylex";
import { ArticleSwitcher } from "./article-switcher";
import { Header } from "./header";
import { HeaderSmall } from "./header-small";
import { SkipNavigation } from "./SkipNavigation";
export function SiteHeader() {
    return <header>
      <SkipNavigation id="main"/>

      <div className="x1s85apg x1opy629">
        <Header/>
        <ArticleSwitcher/>
      </div>

      <div className="x1lliihq x1gzydxp">
        <HeaderSmall/>
      </div>
    </header>;
}
